import { useAtom } from "jotai";
import { selectedStyleAtom, tabsApiAtom } from "../constants/budget-atom";
import BudgetPaginationButton from "../ui/budget-pagination-button";
import { useRouter } from "next/router";
import { kBudgetConfig, kBudgetStyles } from "../constants/budget-translations";
import { useMemo } from "react";
import Image from "next/image";
import MalaysiaFlag from "@public/malaysian_flag_emoji.png";

const BudgetStyleButton: React.FC<{
  styleKey: string;
  emoji: string;
  text: string;
}> = ({ styleKey, emoji, text }) => {
  const [selectedStyle, setSelectedStyle] = useAtom(selectedStyleAtom);

  /// Called when a style is selected, updates the query param with the corresponding style value
  function onStyleSelected() {
    if (styleKey != selectedStyle) {
      setSelectedStyle(styleKey);
    } else {
      setSelectedStyle("");
    }
  }

  return (
    <div>
      <button
        onClick={onStyleSelected}
        className={`flex w-full items-center justify-center space-x-2 rounded-xl transition-all duration-300 ease-in-out ${
          selectedStyle == styleKey ? "bg-secondary" : "bg-off-white"
        } py-4 px-6 font-poppins text-lg`}
      >
        {styleKey == "bahasa_malaysia" ? (
          <Image src={MalaysiaFlag} height={22} width={22} alt="Copy" />
        ) : (
          <span>{emoji}</span>
        )}
        <span>{text}</span>
      </button>
    </div>
  );
};

const BudgetStyleSelection: React.FC = () => {
  const [tabsApi] = useAtom(tabsApiAtom);
  const [selectedStyle] = useAtom(selectedStyleAtom);
  const router = useRouter();
  const { locale } = router;
  const copies = useMemo(
    () => kBudgetConfig(selectedStyle ? selectedStyle : locale),
    [locale, selectedStyle]
  );

  function addStyleToParams() {
    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, style: selectedStyle },
      },
      undefined,
      { shallow: true }
    );
  }

  return (
    <>
      <div className="flex-1 px-8 py-6">
        <h1 className="mb-6 text-center font-poppins text-2xl text-xl font-bold">
          {copies.kPickStyleBreadcrumb}
        </h1>
        <div className="space-y-3">
          {Object.entries(kBudgetStyles).map(([key, { emoji, label }]) => (
            <BudgetStyleButton
              key={key}
              styleKey={key}
              emoji={emoji}
              text={label}
            />
          ))}
        </div>
        <BudgetPaginationButton
          placeholderText={copies.kPickStyleBreadcrumb}
          activeText={copies.kNextButton}
          onClick={
            selectedStyle
              ? () => {
                  tabsApi.scrollNext();
                  addStyleToParams();
                }
              : null
          }
          showActiveText={selectedStyle !== ""}
        />
      </div>
    </>
  );
};

export default BudgetStyleSelection;
